export default {
  form: {
    organization_name: '学校・団体名',
    student_name: '生徒氏名',
    phone_number: '電話番号',
    email: 'メールアドレス',
    content: 'お問い合わせ内容',
    order_id: '注文番号',
  },
  button: {
    submit: '送信',
  },
  message: {
    success: 'お問い合わせが正常に送信されました。',
    error: 'エラーが発生しました。もう一度お試しください。',
  },
  table: {
    id: 'ID',
    school_group_name: '学校・団体名',
    customer_name: '保護者名',
    student_name: '生徒氏名',
    email: 'メールアドレス',
    phone_number: '電話番号',
    content: '問い合わせ内容',
    admin_comment: 'コメント',
    assigned_to: '担当業者',
    status: '対応状況',
    created_at: '作成日',
    order_id: '対象注文',
    resolved_at: '完了日時',
    actions: '操作',
  },
  status: {
    all: 'すべて',
    pending: '未対応',
    processing: '対応中',
    resolved: '完了',
    rejected: '拒否',
  },
  comment: 'コメント',
  comment_placeholder: '管理者コメントを入力してください',
  detail: {
    title: 'お問い合わせ詳細',
  },
  resolved_at: '完了日時',
};
